module.exports = __webpack_public_path__ + "static/media/Lina.f4ae0e31.png";